export function normalizePago(raw) {
  if (!raw) return null;

  const fechaPago =
    raw.fecha_pago ||
    raw.fechaPago ||
    raw.created_at ||
    raw.createdAt ||
    raw.fecha ||
    null;

  const estudiante = raw.estudiante_nombres
    ? `${raw.estudiante_nombres} ${raw.estudiante_apellidos || ""}`.trim()
    : raw.estudiante || null;

  return {
    id: raw.id,
    matriculaId: raw.matricula_id ?? raw.matriculaId ?? null,
    codigoMatricula: raw.codigo_matricula ?? raw.codigoMatricula ?? null,
    cajeroId: raw.cajero_id ?? raw.cajeroId ?? null,
    monto: Number(raw.monto ?? 0),
    metodoPago: raw.metodo_pago ?? raw.metodoPago ?? "efectivo",
    concepto: raw.concepto ?? raw.concepto_pago ?? raw.conceptoPago ?? "matricula",
    afectaMatricula: raw.afecta_matricula != null ? Boolean(raw.afecta_matricula) : true,
    cargoEstado: raw.cargo_estado ?? null,
    referencia: raw.referencia_externa ?? raw.referencia ?? raw.referencia_pago ?? "",
    comprobanteUrl: raw.comprobante_url ?? raw.comprobanteUrl ?? null,
    estadoPago: raw.estado_pago ?? raw.estadoPago ?? null,
    estadoMatricula: raw.estado_matricula ?? raw.estadoMatricula ?? null,
    activo: raw.activo ?? true,
    createdAt: raw.created_at ?? raw.createdAt ?? null,
    fechaPago,
    estudiante,
    estudianteNombres: raw.estudiante_nombres,
    estudianteApellidos: raw.estudiante_apellidos,
    precioFinal: raw.precio_final ?? raw.precioFinal,
    totalPagado: raw.total_pagado ?? raw.totalPagado,
    anulado: Boolean(raw.anulado),
    deletedAt: raw.deleted_at ?? null,
    contificoNumeroFactura: raw.contifico_numero_factura ?? null,
    contificoDocumentoId: raw.contifico_documento_id ?? null,
  };
}
